import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { trackCPD1000Click, trackCPD1000BannerShow } from './tracking';
import { CPD1000Banner } from '../../components/CPD1000Banner';

export function CPD1000BannerContainer() {
  const bannerUrl = 'https://promo.cian.site/1000';

  return (
    <ActionAfterViewObserver callback={trackCPD1000BannerShow} percentVisible={0.8} triggerOnce>
      <CPD1000Banner url={bannerUrl} onClick={trackCPD1000Click} />
    </ActionAfterViewObserver>
  );
}
